module.exports = __webpack_public_path__ + "img/pascal_hugo_boutrais.d36f7b8c.webp";